import React from 'react';
import PropTypes from 'prop-types';
import HelpBlock from "./forms/HelpBlock";

const Filter = ({title, items, renderOption, filter, onSelect, width, error, disabled}) => (
  <React.Fragment>
    <select style={{width}} className="form-control" value={filter} disabled={disabled} onChange={({currentTarget: {value}}) => onSelect(value)}>
      <option value="">{title}</option>
      {items.map(renderOption)}
    </select>
    {error && (<HelpBlock type="error"/>)}
  </React.Fragment>
);

Filter.propTypes = {
  width: PropTypes.number,
  filter: PropTypes.string,
  items: PropTypes.array.isRequired,
  title: PropTypes.string.isRequired,
  onSelect: PropTypes.func.isRequired,
  renderOption: PropTypes.func.isRequired,
  error: PropTypes.bool,
  disabled: PropTypes.bool
};

export default Filter;



// WEBPACK FOOTER //
// ./src/components/Filter.js